import React from "react";

import Footer from "../../components/Footer";
import Header from "../../components/Header";
import ProductCard from '../../components/ProductCard'

const About = () => {
    return (
        <>
            <Header />
            <div className="container pb-5 mb-5">
                <h1 className="display-4">Quem somos</h1>
                <div className="row">
                    <div className="col-sm-6 col-md-6 lead">
                        <h2 className="text-info">Somos uma família de artesãos, que com a magia do amor transforma linhas e mantas em objetos personalizados e únicos.</h2>
                        <br />
                        <h2 className="text-info">Faça sua encomenda!</h2>
                    </div>
                    <div className="col-sm-3 col-md-4">
                        <ProductCard img={"https://firebasestorage.googleapis.com/v0/b/amigurumimagia-8c2d7.appspot.com/o/amigurumi%2Fabout_boneca.jpg?alt=media&token=376013da-c006-4ace-8d4c-05421698cc62"} />
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
}

export default About;